<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-input ttLabel="project_keyno_and_name" [ttModel]="menu.project_keyno_and_name" ttReadonly [ttButtons]="projectKeynoAndNameButtons"></tt-input>
        <tt-input ttLabel="cust_no_and_name" [ttModel]="menu.cust_no_and_name" ttReadonly [ttButtons]="custNoAndNameButtons"></tt-input>

        <tt-tabs ttRememberId="w_projectinvoicing.tab" [(ttSelectedId)]="menu.selected_tab">
            <tt-tab ttId="SELECT" ttLabel="bg_projectinvoicing_main_select"></tt-tab>
            <tt-tab ttId="SHOW" ttLabel="bg_projectinvoicing_main_show"></tt-tab>
            <tt-tab ttId="INVOICED" ttLabel="bg_projectinvoicing_main_invoiced"></tt-tab>
        </tt-tabs>

        <div [hidden]="menu.selected_tab !== 'SELECT'">
            <tt-button-save ttText="projectinvoicing_save_selection" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
            <tt-button ttText="projectinvoicing_set_not_invoicing" (ttClick)="setNotValues()" ttIcon="fas fa-sync-alt" ttType="danger" [ttLoading]="settingNot"></tt-button>
        </div>

        <div [hidden]="menu.selected_tab !== 'SHOW'">
            <tt-date ttLabel="invoice_date" [(ttModel)]="menu.invoice_date"></tt-date>
            <tt-button-save ttText="projectinvoicing_make_invoice" (ttClick)="createChanges()" [ttLoading]="creatingInvoice" ttType="primary"></tt-button-save>
        </div>
    </tt-card>

    <tt-grid [hidden]="menu.selected_tab !== 'SELECT'" *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
    <tt-grid [hidden]="menu.selected_tab !== 'SHOW'" *ngIf="!!gridBase" class="p-5 flex-1" [(ttOptions)]="gridBase"></tt-grid>
    <tt-grid [hidden]="menu.selected_tab !== 'INVOICED'" *ngIf="!!gridInvoiced" class="p-5 flex-1" [(ttOptions)]="gridInvoiced"></tt-grid>
</tt-page>
